import { render } from "./Positions.vue?vue&type=template&id=5d3a6241"
import script from "./Positions.vue?vue&type=script&lang=js"
export * from "./Positions.vue?vue&type=script&lang=js"

import "./Positions.vue?vue&type=style&index=0&id=5d3a6241&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__